<template>
  <div id="app">
    <pc-area />
    <inventory />
  </div>
</template>

<script>
import PcArea from './views/PcArea.vue'
import Inventory from './views/Inventory.vue'

export default {
  name: 'app',
  data: ()=>({
  }),
  components: {
    'pc-area': PcArea,
    'inventory': Inventory,
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100vh;
  width: 100%;
}
html, body{
  max-height: 100vh;
  background-color: #555;
  margin: 0;
  overflow-y: auto !important;
}
</style>
